import {Directive, forwardRef, Attribute, Input} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector:
  '[validateDateControl][formControlName],[validateDateControl][formControl],[validateDateControl][ngModel],' +
  '[validateDateType][formControlName],[validateDateType][formControl],[validateDateType][ngModel],' +
  '[validateReverseControl][formControlName],[reverse][formControl],[validateReverseControl][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DateValidator), multi: true }
  ]
})

export class DateValidator implements Validator {

  @Input() validateDate : Date;
  @Input() validateDateType: string;

  constructor( @Attribute('validateDateControl') public validateDateControl: string = null,
               @Attribute('validateReverseControl') public validateReverseControl: string = "false"
               ) {}


  public isValid(currentValue : Date, controlValue : Date, checkType : string) : boolean {

    let compare = true;

    console.log(currentValue);
    console.log(checkType);
    console.log(controlValue)
    switch (checkType)
    {
      case "<":
        compare = currentValue< controlValue;
        break;
      case "<=":
        compare = currentValue <= controlValue;
        break;
      case "=":
        compare = currentValue === controlValue;
        break;
      case ">=":
        compare = currentValue >= controlValue;
        break;
      case ">":
        compare = currentValue > controlValue;
        break;
    }
    console.log(compare);
    return compare;

  }

  private get isReverse() {
    if (!this.validateReverseControl) return false;
    return this.validateReverseControl === 'true' ? true: false;
  }

  validate(c: AbstractControl): {[p: string]: any} {
    if (c.value) {


      let controlValue = null;
      if (this.validateDateControl != null)
        controlValue = c.parent.controls[this.validateDateControl];
      else
        controlValue = this.validateDate;
      let controlEvaluate = this.validateDateControl != null ? new Date(controlValue.value) : new Date(controlValue);



      let compare = this.isValid(new Date(c.value), controlEvaluate, this.validateDateType);

      if (this.validateDateControl != null) {
        if (!compare) {
          if (this.isReverse) controlValue.setErrors({validateDate: false});
          return {
            validateDate: false
          }
        } else {
          if (this.isReverse) controlValue.setErrors(null);
          return null;
        }
      } else return compare ? null : {validateDate: false};

    } else return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/validators/DateValidator.ts